import styled from 'styled-components';
import { media } from '../../utils/styles/media';
import { colors } from '../../utils/styles/colors';

export const CollaborationCardContainer = styled.div`

    padding: 15px;
    width: 25%;
    .front{
        width: 100%;
        height: 680px;
        background-repeat: no-repeat;
        background-position: 50% 50%;
        background-size: cover;
        border-radius: 15px;
        position: relative;
        .companyIcon{
            width: 150px;
            height: 150px;
            position: absolute;
            bottom: 30px;
            right: 30px;
            border-radius: 50%;
        }
    }
    .company{
        position: relative;
        width: 90px;
        height: 90px;
        border-radius: 50%;
        bottom: 21%;
        left: 65%;
        background-repeat: no-repeat;
        background-position: 50% 50%;
        background-size: cover;
    }            
    .name{
        font-size: 2.4rem;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 100%;
        color: ${colors.text};
    }

    /**----------Responsive----------*/
    ${media.largeDesktop}{
        .front{
            //height: 540px;
            height: 27vw;
            .companyIcon{
                width: 100px;
                height: 100px;
            }
        }
        .name{
            font-size: 1.8rem;
        }  
    }

    ${media.macdesktop}{
        .front{
            //height: 540px;
            height: 27vw;
            .companyIcon{
                width: 100px;
                height: 100px;
            }
        }
        .name{
            font-size: 1.6rem;
        }  
    }

    ${media.desktop}{
        
        .front{
            height: 360px;
            .companyIcon{
                width: 80px;
                height: 80px;
                bottom: 20px;
            right: 20px;
            }
        }  
        .name{
            font-size: 1.5rem;
        }

    }
    ${media.smallDesktop}{
        padding: 10px;
        .front{
            height: 300px;
            .companyIcon{
                width: 70px;
                height: 70px;
                bottom: 15px;
                right: 15px;
            }
        }  

    }

    ${media.laptop}{
        padding: 8px;
        .front{
            height: 230px;
            .companyIcon{
                width: 55px;
                height: 55px;
                bottom: 15px;
                right: 15px;
            }
        }  
        .name{
            font-size: 1rem;
        }

    }
    ${media.tablet}{
        .front{
            height: 200px;
        }
    }

    ${media.largeMobile}{
        width: 50%;
        .front{
            height: 180px;
            .companyIcon{
                width: 50px;
                height: 50px;
                bottom: 10px;
                right: 10px;
            }
        } 
        .company{
            width: 24%;
            height: 22%;
            bottom: 30%;
            left: 70%;
        }
    }
`